import React from 'react'
import { Box, Grid, Paper, Typography, Checkbox } from '@mui/material'
import DOMPurify from 'dompurify'
import Avatar from '@/feature/user/avatar/Avatar'
import { brandedTokens } from '@/theme/tokens'
import { MessageContentProps } from './types'

const MessageContent: React.FC<MessageContentProps> = ({
    item,
    filter,
    kedo,
    hasCheckedItem,
    updateCheckedStatus,
    handleItemClick,
}) => {
    const isChecked = Boolean(hasCheckedItem(item))
    const isUnread = !item.read_date && filter !== 'outgoing'
    const senderName = item.sender_name?.trim() || ''
    const hasSender = Boolean(item.sender_id && senderName)

    return (
        <Paper
            key={item.id}
            elevation={isUnread ? 3 : 1}
            sx={{
                mb: 1,
                p: 1.5,
                cursor: 'pointer',
                bgcolor: isUnread ? 'action.hover' : 'background.paper',
            }}
        >
            <Grid container spacing={2} alignItems="flex-start">
                <Grid size="auto">
                    <Checkbox
                        checked={isChecked}
                        onChange={(event) => updateCheckedStatus(event, item)}
                    />
                </Grid>

                <Grid size="auto">
                    <Avatar
                        kedo={kedo}
                        user={{
                            userId: hasSender ? item.sender_id : undefined,
                            username: hasSender ? senderName : 'User',
                        }}
                        options={{
                            size: 38,
                            showPresence: false,
                        }}
                        props={{ kedo }}
                    />
                </Grid>

                <Grid size="grow" onClick={() => handleItemClick(item.id)}>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        {hasSender ? (
                            <Typography
                                variant="subtitle2"
                                className="badge badge-primary"
                                color="text.primary"
                                fontWeight={isUnread ? 600 : 400}
                            >
                                {senderName}
                            </Typography>
                        ) : (
                            <Box />
                        )}

                        <Typography
                            variant="caption"
                            className="badge badge-secondary"
                            sx={{
                                color: (theme) => theme.palette.common.white,
                                bgcolor: brandedTokens.variables.secondary,
                            }}
                        >
                            {kedo.utils().dateFormat(item.created_at)}
                        </Typography>
                    </Box>

                    <h6 className="readMore">{item.title}</h6>

                    <Box
                        className="readMore messageOverview"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.message_text),
                        }}
                    />
                </Grid>
            </Grid>
        </Paper>
    )
}

export default MessageContent
